import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  }, {
    path: '/about',
    name: 'About',
    component: () => import('@/views/Home.vue')
  }, {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  }, {
    path: '/registro',
    name: 'RegistroForm',
    component: () => import('@/views/registro/RegistroForm.vue'),
  },
  //esta vista es para registrar los antecedentes del paciente
  {
    path: '/antecedentesmedicos',
    name: 'PacienteNuevoAntecedentes',
    component: () => import('@/views/paciente/PacienteNuevoAntecedentes.vue'),
  }, {
    path: '/cita',
    name: 'CitasForm',
    component: () => import('@/views/citas/CitasForm.vue'),
  }, {
    path: '/confirmaciondecita/:idCit?',
    name: 'CitasConfirmacion',
    component: () => import('@/views/citas/CitasConfirmacion.vue'),
  }, {
    path: '/paciente',
    name: 'PacienteForm',
    component: () => import('@/views/paciente/PacienteForm.vue'),
  },
  //encuesta de satifsaccion
  {
    path: '/encuesta',
    name: 'EncuestaForm',
    component: () => import('@/views/encuesta/EncuestaForm.vue')
  }, {
    path: '/nosotros',
    name: 'NosotrosView',
    component: () => import('@/views/nosotros/NosotrosView.vue')
  }, {
    path: '/paciente/historiaclinica',
    name: 'PacientesHistoriaClinica',
    component: () => import('@/views/paciente/PacientesHistoriaClinica.vue'),
    redirect: '/paciente/historiaclinica/citas',
    children: [
      {
        path: 'citas',
        component: () => import('@/views/paciente/detalle/PacientesDetalleCitas.vue'),
      }, {
        path: 'antecedentes',
        component: () => import('@/views/paciente/detalle/PacientesDetalleAntecedentes.vue'),
      }, {
        path: 'consentimientos',
        component: () => import('@/views/paciente/detalle/PacientesDetalleConsentimientos.vue'),
      }, {
        path: 'consultas',
        component: () => import('@/views/paciente/detalle/PacientesDetalleConsultas.vue'),
      }, {
        path: 'odontogramas',
        component: () => import('@/views/paciente/detalle/PacientesDetalleOdontogramas.vue'),
      }, {
        path: 'odontogramasinfantil',
        component: () => import('@/views/paciente/detalle/PacientesDetalleOdontogramasInfantiles.vue'),
      }, {
        path: 'pagos/:estatus?',
        component: () => import('@/views/paciente/detalle/PacientesDetallePagos.vue'),
      }, {
        path: 'planesdetratamiento',
        component: () => import('@/views/paciente/detalle/PacientesDetallePlanesTratamiento.vue'),
      }, {
        path: 'galeriadetratamiento',
        component: () => import('@/views/paciente/detalle/PacientesDetalleGaleriaTratamiento.vue'),
      }, {
        path: 'garantias',
        component: () => import('@/views/paciente/detalle/PacientesDetalleGarantias.vue'),
      },
    ]
  },
]

const router = new VueRouter({
  routes
})

export default router
